export interface HttpRequestMeta {
  method: string;
  url: string;
  headers?: Record<string, any>;
  body?: any;
}

export class HttpError extends Error {
  status: number | null;
  statusText: string | null;
  data: any;
  _request?: HttpRequestMeta;
  _rawError?: any;

  constructor(
    message: string,
    opts?: {
      status?: number | null;
      statusText?: string | null;
      data?: any;
      request?: HttpRequestMeta;
      raw?: any;
    },
  ) {
    super(message);
    this.name = "HttpError";
    this.status = opts?.status ?? null;
    this.statusText = opts?.statusText ?? null;
    this.data = opts?.data;
    if (opts?.request) this._request = opts.request;
    if (opts?.raw !== undefined) this._rawError = opts.raw;
  }
}
